import { Form, Input, message } from 'antd';
import React, { useRef, useState } from 'react'
import { useDispatch } from 'react-redux';
import { fetchPatMappedRpmDevList } from '../../../../../Redux/actions/rpmActions';

function DevicesFilter({ handleClose,setDeviceFiltered,selectedRpmPatient }) {
    const [loader,setLoader] = useState(false);
    const formRef = useRef();
    const dispatch = useDispatch();

    const handleDeviceFilter = async () => {
        const values = formRef.current?.getFieldValue?.();
        if (!values) return;

        const { deviceCode, deviceName, deviceBrand, deviceModel } = values;

        if (!deviceCode && !deviceName && !deviceBrand && !deviceModel) {
            message.error("Enter any fields to filter the devices.");
            return;
        }
        setLoader(true);
        const payload = {patientCode: selectedRpmPatient.patientId,status:1};
        if (deviceCode) payload.deviceCode = deviceCode;
        if (deviceName) payload.deviceName = deviceName;
        if(deviceBrand) payload.deviceBrand = deviceBrand;
        if(deviceModel) payload.deviceModel = deviceModel;


        dispatch(fetchPatMappedRpmDevList(payload));
        setDeviceFiltered(true);
        handleClose();
        setLoader(false);

    }


    return (
        <>
            <Form layout='vertical' ref={formRef} disabled={loader}>
                <div className='grid grid-cols-2 items-center justify-center gap-2'>
                    <div>
                        <Form.Item label="Code" name="deviceCode">
                            <Input placeholder="Enter" />
                        </Form.Item>
                    </div>
                    <div>
                        <Form.Item label="Device" name="deviceName">
                            <Input placeholder="Enter" />
                        </Form.Item>
                    </div>
                    <div>
                        <Form.Item label="Brand" name="deviceBrand">
                            <Input placeholder="Enter" />
                        </Form.Item>
                    </div>
                    <div>
                        <Form.Item label="Model" name="deviceModel">
                            <Input placeholder="Enter" />
                        </Form.Item>
                    </div>
                </div>
            </Form>
            <div>
                <div className="flex items-center w-full justify-end my-5">
                    <button disabled={loader} onClick={handleClose} className=" border rounded bg-white text-sm px-6 py-1.5 disabled:cursor-not-allowed disabled:opacity-50">
                        Cancel
                    </button>
                    <button disabled={loader} onClick={handleDeviceFilter} className="bg-brand-primaryColor border rounded px-5 py-1.5 text-white text-sm ml-3 disabled:cursor-not-allowed disabled:opacity-50">
                        Submit
                    </button>
                </div>
            </div>
        </>
    )
}

export default DevicesFilter;